import { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

const ExitIntentPopup = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [hasShown, setHasShown] = useState(false);

  useEffect(() => {
    const handleMouseLeave = (e: MouseEvent) => {
      // Detect when mouse leaves the top of the page (exit intent)
      if (e.clientY <= 0 && !hasShown) {
        setShowPopup(true);
        setHasShown(true);
      }
    };

    // Add a small delay before enabling exit intent detection
    const timer = setTimeout(() => {
      document.addEventListener('mouseleave', handleMouseLeave);
    }, 3000); // Wait 3 seconds before enabling

    return () => {
      clearTimeout(timer);
      document.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, [hasShown]);

  const handleRedirect = () => {
    window.location.href = '/#lead-form';
    setShowPopup(false);
  };

  const handleClose = () => {
    setShowPopup(false);
  };

  return (
    <Dialog open={showPopup} onOpenChange={setShowPopup}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold text-center">
            Wait! Don't Leave Just Yet...
          </DialogTitle>
          <DialogDescription className="text-center text-base">
            You're just one step away from transforming your business with our proven marketing system.
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4 py-4">
          <div className="text-center">
            <h3 className="font-semibold text-lg mb-2">Get Your Free Marketing Audit Worth £500</h3>
            <p className="text-muted-foreground">
              Discover exactly how to attract premium clients and scale your revenue by 150%+
            </p>
          </div>
          
          <div className="flex flex-col gap-3">
            <Button 
              onClick={handleRedirect}
              className="w-full bg-primary hover:bg-primary/90 text-white font-semibold py-3"
            >
              Claim My Free Audit Now
            </Button>
            <Button 
              variant="ghost" 
              onClick={handleClose}
              className="w-full text-muted-foreground hover:text-foreground"
            >
              No thanks, I'll figure it out myself
            </Button>
          </div>
        </div>
        
        <button
          onClick={handleClose}
          className="absolute right-4 top-4 opacity-70 hover:opacity-100 transition-opacity"
        >
          <X className="h-4 w-4" />
        </button>
      </DialogContent>
    </Dialog>
  );
};

export default ExitIntentPopup;